import { Link } from "react-router-dom";
import { Reveal, Label } from "@/components/motion";
import { IMAGES } from "@/data/site";

export default function FeatureSikkim() {
  return (
    <section data-testid="home-feature" className="bg-white">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="grid items-start lg:grid-cols-12">
          <Reveal className="lg:col-span-8">
            <div className="group overflow-hidden">
              <img
                src={IMAGES.homeFeature}
                alt="Kanchenjunga at sunrise, Sikkim"
                loading="lazy"
                className="aspect-[16/11] w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.03]"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4">
            <div className="border border-mist bg-white p-10 lg:-ml-24 lg:mt-32 lg:p-14">
              <Label>Destination Feature</Label>
              <h2 className="mt-6 font-serif text-4xl font-light leading-[1.02] tracking-tight text-ink sm:text-5xl">
                Into the Himalayas.
              </h2>
              <p className="mt-8 text-base leading-relaxed text-graphite">
                Wake to mountain light, follow winding roads through quiet valleys,
                discover monasteries hidden among the hills and experience Sikkim at a
                pace that leaves room for the journey itself.
              </p>
              <Link
                to="/destinations/sikkim"
                data-testid="feature-explore-sikkim"
                className="link-arrow mt-10 text-ink hover:text-gold"
              >
                Explore Sikkim
                <span aria-hidden>→</span>
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
